import { render, staticRenderFns } from "./CardTarjaTwitterAngelicaAoVivo.vue?vue&type=template&id=910ca2a8&scoped=true"
import script from "./CardTarjaTwitterAngelicaAoVivo.vue?vue&type=script&lang=js"
export * from "./CardTarjaTwitterAngelicaAoVivo.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaTwitterAngelicaAoVivo.vue?vue&type=style&index=0&id=910ca2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910ca2a8",
  null
  
)

export default component.exports